// Premium Color Palette from PREMIUM_METRIC_PATTERNS.md
export const PREMIUM_COLORS = {
  // Primary Colors
  primaryBlue: '#2A4494',
  primaryGolfGreen: '#1B4332',
  primaryBackgroundCream: '#FDF8F0',

  // Secondary Colors
  secondaryGolfGreen: '#2D5A3D',

  // Accent Colors
  accentBrightGreen: '#52B788',
  accentDeepGreen: '#047857',

  // Background Colors
  backgroundMint: '#F0FDF4',
  cardWhite: 'rgba(255, 255, 255, 0.95)',

  // Status Colors
  successGreen: '#16A34A',
  errorRed: '#DC2626',
  neutralGray: '#9CA3AF',
  darkText: '#374151',

  // Statistics Colors (for graphs/charts - matches birdie/double bogey)
  statisticsGreen: '#16A34A',
  statisticsRed: '#DC2626',

  // Score Colors (Flat)
  eagleColor: '#34D399',
  birdieColor: '#16A34A',
  parColor: '#3B82F6',
  bogeyColor: '#F59E0B',
  doubleBogeyColor: '#DC2626',

  // Score Colors (Gradients)
  eagleGradient: 'linear-gradient(135deg, #34D399 0%, #10B981 100%)',
  achievementGradient: 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)', // Gold for trophies/badges
  birdieGradient: 'linear-gradient(135deg, #16A34A 0%, #15803D 100%)',
  parGradient: 'linear-gradient(135deg, #3B82F6 0%, #2563EB 100%)',
  bogeyGradient: 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)',
  doubleBogeyGradient: 'linear-gradient(135deg, #DC2626 0%, #B91C1C 100%)',

  // Gradients
  primaryGradient: 'linear-gradient(180deg, #FDF8F0 0%, #F0FDF4 100%)',
  blueGradient: 'linear-gradient(135deg, #2A4494 0%, #1E3270 100%)',
  heroGradient: 'linear-gradient(135deg, #52B788 0%, #2D5A3D 50%, #1B4332 100%)',
  activeTabGradient: 'linear-gradient(135deg, #16A34A 0%, #15803D 100%)',

  // Statistics Gradients (for graphs/charts - matches birdie/double bogey)
  statisticsGreenGradient: 'linear-gradient(135deg, #16A34A 0%, #15803D 100%)',
  statisticsRedGradient: 'linear-gradient(135deg, #DC2626 0%, #B91C1C 100%)'
};

// Premium styling system from PREMIUM_METRIC_PATTERNS.md
export const PREMIUM_STYLES = {
  glassMorphCard: {
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(20px)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: '24px',
    boxShadow: '0 8px 32px rgba(27, 67, 50, 0.1)'
  },
  gradientHeroCard: {
    background: 'linear-gradient(135deg, #52B788 0%, #2D5A3D 50%, #1B4332 100%)',
    borderRadius: '24px',
    boxShadow: '0 8px 32px rgba(27, 67, 50, 0.15)'
  },
  iosHeader: {
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(20px)',
    borderBottom: '1px solid rgba(226, 232, 240, 0.5)',
    paddingTop: 'env(safe-area-inset-top, 0px)'
  },
  primaryButton: {
    background: PREMIUM_COLORS.primaryGolfGreen,
    height: '48px',
    borderRadius: '12px',
    boxShadow: '0 8px 32px rgba(27, 67, 50, 0.15)',
    transition: 'all 200ms ease-out'
  }
};


